// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_ma-0";